import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { map } from "lodash";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ListPostItem } from "../ListPostItem";
import { Post } from "../../../../api";
import "./ListPost.scss";

const postController = new Post();

export function ListPost() {
  const [posts, setPosts] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [searchParams] = useSearchParams(); //necesita estar seteado antes del siguinete useState
  const [page, setPage] = useState(searchParams.get("page") || 1);
  const navigate = useNavigate();

  // console.log(posts);

  useEffect(() => {
    (async () => {
      try {
        const response = await postController.getPosts(page, 9);
        setPosts(response.posts.docs);
        setPagination({
          limit: response.posts.limit,
          page: response.posts.page,
          pages: response.posts.totalPages,
          total: response.posts.totalDocs,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page]);

  const changePage = (e, data) => {
    const newPage = data.activePage;
    setPage(newPage);
    navigate(`?page=${newPage}`); //esto pregunta si hay un cambio en la pagina y pagina para luego guardar la pagina en memoria
  };

  if (!posts) return <Loader active inline="centered" />;

  return (
    <div className="list-posts-web">
      <div className="list">
        {map(posts, (post) => (
          <div key={post._id} className="item">
            <ListPostItem post={post} />
          </div>
        ))}
      </div>
      <div className="pagination">
        <Pagination
          totalPages={pagination.pages}
          defaultActivePage={pagination.page}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          secondary
          pointing
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
